import React from 'react';
import I18n from 'i18n-js';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { RCCallout } from '@reverbdotcom/cadence/components';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { InfoIcon, UserCircleIcon, WarningIcon } from '@phosphor-icons/react';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import { IUserContext, withUserContext } from '@reverbdotcom/commons';
import experiments from '@reverbdotcom/commons/src/experiments';
import { signinUrl } from '@reverbdotcom/commons/src/signup_signin_helper';

function GiftCardsUnderConstruction({ user }: IUserContext) {
  const displayUserLoginPrompt = () => {
    return isExperimentEnabled(user, experiments.DISPLAY_USERS_LOGIN_REQUIRED_FOR_GIFT_CARDS);
  };

  return (
    <div className="mt-4 mb-4">
      { !displayUserLoginPrompt() &&
        <>
          <RCCallout
            themeType="utility"
            variant="notice-ultralight"
            title={I18n.t('discovery.giftCardsUnderConstruction.unavailableTitle')}
            icon={<WarningIcon />}
          >
            <Translate
              tag="p"
              text="discovery.giftCardsUnderConstruction.unavailableMessageHtml"
            >
              <CoreLink to="https://reverb.com/news/last-minute-gifts-musicians-will-actually-love">
                <Translate text="discovery.giftCardsUnderConstruction.giftIdeasLinkText" />
              </CoreLink>
            </Translate>
          </RCCallout>

          <div className="mt-4">
            <RCCallout
              themeType="utility"
              variant="info-ultralight"
              title={I18n.t('discovery.giftCardsUnderConstruction.redeemTitle')}
              icon={<InfoIcon />}
            >
              <Translate
                tag="p"
                text="discovery.giftCardsUnderConstruction.redeemHtml"
              >
                <CoreLink to="/redeem">
                  <Translate text="discovery.giftCardsUnderConstruction.redeemLinkText" />
                </CoreLink>
              </Translate>
            </RCCallout>
          </div>
        </>
      }
      { displayUserLoginPrompt() &&
        <div className="mt-4">
          <RCCallout
            themeType="utility"
            variant="info-ultralight"
            title={I18n.t('discovery.giftCardsUnderConstruction.loginPromptTitle')}
            icon={<UserCircleIcon />}
          >
            <Translate
              tag="p"
              text="discovery.giftCardsUnderConstruction.loginPromptHtml"
            >
              <CoreLink to={signinUrl('GiftCards', window.location.href)}>
                <Translate text="discovery.giftCardsUnderConstruction.loginLinkText" />
              </CoreLink>
            </Translate>
          </RCCallout>
        </div>
      }
    </div>
  );
}

export default withUserContext(GiftCardsUnderConstruction);
